export default __webpack_public_path__ + "static/media/visa.b2195b66.svg";